// extracted by mini-css-extract-plugin
export default {"popup":"popup-T7TlSxy6","animateFromTop":"animateFromTop-RtzvSiJF"};